import actionFe from 'utils/mw/actionFe.util';

import { getNextId } from './consultationForms.mock';

export const feConsultationFormsFetchSuccess = actionFe('feConsultationFormsFetchSuccess');
export const feConsultationFormCreate = actionFe('feConsultationFormCreate');
export const feConsultationFormUpdate = actionFe('feConsultationFormUpdate');
export const feConsultationFormDelete = actionFe('feConsultationFormDelete');
export const feConsultationFormToggleStatus = actionFe('feConsultationFormToggleStatus');
export const feConsultationFormDuplicate = actionFe('feConsultationFormDuplicate');

export const createConsultationForm = (formData) => (dispatch) => {
  const newForm = { ...formData, id: getNextId() };
  dispatch(feConsultationFormCreate(newForm));
  return newForm;
};

export const duplicateConsultationForm = (formId) => (dispatch, getState) => {
  const forms = getState().settings.consultationForms.forms;
  const original = forms.find((f) => f.id === formId);
  if (!original) return;

  const duplicate = {
    ...original,
    id: getNextId(),
    name: `${original.name} (copy)`,
    status: 'draft',
    questions: original.questions.map((q) => ({
      ...q,
      id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    })),
  };
  dispatch(feConsultationFormDuplicate(duplicate));
};
